import React, { useEffect, useState } from "react";
import { CommonFieldsData, locations } from "../networking";
import { Link } from "react-router-dom";
import { Button, Table } from "@mui/material";

interface Location {
  id: string;
  descrizione: string;
}

const Locations = () => {
  const [locationsData, setLocationsData] = useState<Location[]>([]);

  // Oggetto di filtro per la richiesta API
  let locationFilters: CommonFieldsData = {
    tipoAgenda: "",
    specialita: "",
    prestazione: "",
    medico: undefined,
    dataInizio: "",
    dataFine: "",
  };

  useEffect(() => {
    // Funzione per recuperare i dati delle sedi dall'API
    const fetchData = async () => {
      try {
        const response = await locations(locationFilters); //Funzione locations presente nel file networking.ts
        const data = response.data.dati;

        // Converto i dati ricevuti dall'API in un array di oggetti Location
        const locationsArray = Object.entries(data).map(([key, value]) => ({
          id: key,
          descrizione: (value as { DESCRIZIONE: string }).DESCRIZIONE,
        }));

        //Salvo i nuovi dati nello state locationsData
        setLocationsData(locationsArray);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>Sedi</th>
            <th>Descrizione</th>
          </tr>
        </thead>
        <tbody>
          {locationsData.map((location, index) => (
            <tr key={location.id}>
              <td>{location.id}</td>
              <td>{location.descrizione}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Link to="/">
        <Button>Login</Button>
      </Link>
    </>
  );
};

export default Locations;
